const acceptedProtocols = ['//', 'http://', 'https://'];

export function urlParts (hostString: string, url: string) {
  if (url[0] === '/' && url[1] !== '/') {
    return {
      isOuter: false,
      link: url,
    };
  }
  if (['', ...acceptedProtocols].some(protocol => url === `${protocol}${hostString}`)) {
    return {
      isOuter: false,
      link: '/',
    };
  }
  const protocolPart = ['', ...acceptedProtocols].find(protocol => url.startsWith(`${protocol}${hostString}/`));
  if (typeof protocolPart === 'string') {
    return {
      isOuter: false,
      link: url.slice(`${protocolPart}${hostString}`.length),
    };
  }
  if (acceptedProtocols.some(p => url.startsWith(p))) {
    return {
      isOuter: true,
      link: url,
    };
  }
  return {
    isOuter: false,
    link: `/${url}`,
  };
}

export function hyperlinkComputeBindFromUrl (hostString: string, url: string) {
  const { isOuter, link } = urlParts(hostString, url);
  return {
    ...(isOuter ? { target: '_blank' } : null),
    [isOuter ? 'href' : 'to']: link,
  };
}
